import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../Home/Card";
import axios from "axios";
import "./Featured.css";

const BestDeals = () => {
  const [carData, setCarData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const { data } = await axios.get(
          "https://automotive-backend-production.up.railway.app/inventory/tag/featured?page=1&limit=16"
        );
        // Assuming API returns { cars: [...], totalCount: n }
        setCarData(data.cars); // ✅ Use the correct key from response
      } catch (error) {
        console.error("Error fetching car data:", error);
      }
    };
    fetchCars();
  }, []);

  return (
    <div className="container deal-container my-4">
      {/* Header Section */}
      <div className="featured-header">
        <h5>Featured</h5>
        <button className="orange-button" onClick={() => navigate("Inventory")}>
          Inventory
        </button>
      </div>

    <div className="row row-cols-1 row-cols-md-4 g-4">
  {Array.isArray(carData) &&
    carData.map((car) => {
      // Check thumbnail first, then gallery, then placeholder
      const image = car.Thumbnail
        ? `https://automotive-backend-production.up.railway.app/${car.Thumbnail}`
        : car.ImageURL && car.ImageURL[0]
        ? `https://automotive-backend-production.up.railway.app/${car.ImageURL[0]}`
        : "https://via.placeholder.com/300x200?text=No+Image";

      return (
        <div className="col" key={car._id}>
          <Card
            id={car._id}
            image={image}
            title={car.Name}
            price={car.Price}
            year={car.Year}
            transmission={car.Transmission}
            fuel={car.FuelType}
            tag={car.tags}
            km={car.Mileage}
            RecordNumber={car.RecordNumber}
          />
        </div>
      );
    })}
</div>

    </div>
  );
};

export default BestDeals;
